export const isTruncated = (el: HTMLElement | null) => {
  return (el?.scrollWidth ?? 0) > (el?.clientWidth ?? 0);
};

export const isLineClamp = (el: HTMLElement | null) => {
  return (el?.scrollHeight ?? 0) > (el?.clientHeight ?? 0);
};
